export default __webpack_public_path__ + "bookmark-white.png";